import { useParams } from 'react-router-dom'
import { postRequest } from '../../../../../services/base'
import Button from '../../../../common/Button'
import FileField from '../../../../common/FileField'
import InputText from '../../../../common/InputText'
import { useContext } from 'react'
import { NavContext } from '../../../../../context/global_context'
import TextArea from '../../../../common/TextArea'

const PluginForm = (props) => {
  const [state, dispatch] = useContext(NavContext)
  const { vehicle } = useParams()

  const uploadDefFiles = async (e) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'DEF file upload is in progress...',
        showLoader: true,
      },
      notification: {},
    })
    const form = e.target
    const formData = new FormData(form)
    let res = await postRequest(
      `/api/plugin/def/upload_def/${vehicle}/`,
      formData
    )
    if (res.status) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File uploaded successfully! Please click to generate files button',
        },
      })
      props.onSave()
    } else {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res.msg,
        },
      })
    }
  }

  return (
    <div className="">
      <form
        onSubmit={(e) => {
          e.preventDefault()
          uploadDefFiles(e)
        }}
      >
        <div className="flex">
          <div className="w-1/2">
            <FileField label="Def File" name="plugin_view" />
          </div>
          <div className="w-1/2">
            <FileField label="Supp File" name="supp_file" isRequired={false} />
          </div>
        </div>
        <div className="flex">
          <div className="w-1/2">
            <InputText name="file_id" label="File Id" />
          </div>
          <div className="w-1/2 text-white">
            <InputText name="description" label="Description" />
          </div>
        </div>
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="abbreviation"
              label="Abbreviation"
              isRequired={false}
              maxLength={6}
            />
          </div>
        </div>
        <div className="flex justify-end">
          <div className="w-1/4 mr-2">
            <Button
              type="submit"
              className={`cursor-pointer btn my-4 w-full justify-end`}
              onClick={(e) => {}}
              value={'text'}
              text={'Save'}
            />
          </div>
        </div>
      </form>
    </div>
  )
}

export default PluginForm
